import * as yup from "yup";

export const singleDocumentsSchema = yup.object().shape({
  document: yup
    .string()
    .max(50, "The file name must be no more than 50 characters.")
    .test({
      name: "noOnlySpaces",
      message: "The field is required.",
      test: (value) => {
        return value.trim() !== "";
      },
    })
    .required("The field is required."),
});
